import { useLocales } from 'src/contexts'

export const useAnalytics = () => {
  const { translations } = useLocales()
  const breadcrumbItems = [
    { labelKey: translations.breadcrumbItems.home, href: '/' },
    { labelKey: translations.breadcrumbItems.analytics },
  ]

  return { breadcrumbItems }
}
